import { createRouter as createTanstackRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { PAGE_SCROLL_CONTAINER_ID } from "./lib/page-scroll-container";
import * as TanstackQuery from "./integrations/tanstack-query/root-provider";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
export const createRouter = () => {
  const rqContext = TanstackQuery.getContext();

  const router = createTanstackRouter({
    routeTree,
    context: { ...rqContext },
    defaultPreload: "intent",
    // Pages scroll inside the layout's <main>, not the window, so the router's
    // reset-to-top on navigation has to be pointed at it too. Without this the
    // next page (e.g. order -> checkout) opens at the previous scroll offset.
    scrollToTopSelectors: [`#${PAGE_SCROLL_CONTAINER_ID}`],
    // Do NOT set Wrap here — setupRouterSsrQueryIntegration handles
    // wrapping with QueryClientProvider automatically. Having two
    // nested providers causes dehydration issues during SSR.
  });

  setupRouterSsrQueryIntegration({
    router,
    queryClient: rqContext.queryClient,
  });

  return router;
};

// Export as getRouter for routeTree.gen.ts compatibility
export const getRouter = createRouter;

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
